module.exports = __webpack_public_path__ + "img/icon_resize_gamkat.bf487786.webp";